import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import './LoginModal.css';

const LoginModal = ({ isOpen, onClose, onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/api/auth/login', {
        username,
        password
      });
      
      if (response.data.success) {
        // Enregistrer le token dans le localStorage
        localStorage.setItem('token', response.data.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.data.user));
        
        // Mettre à jour les headers axios pour les futures requêtes
        axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.data.token}`;
        
        toast.success('Connexion réussie');
        
        // Appeler le callback de succès
        onLoginSuccess(response.data.data);
        
        // Fermer la modal
        onClose();
        
        // Réinitialiser le formulaire
        setUsername('');
        setPassword('');
      }
    } catch (err) {
      setError(
        err.response?.data?.error || 
        'Erreur de connexion. Veuillez vérifier vos identifiants.'
      );
      toast.error('Échec de la connexion');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="login-modal-overlay" onClick={onClose}>
      <div className="login-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="login-modal-body">
          <div className="login-modal-header">
            <h2 className="login-modal-title">Connexion requise</h2>
            <button
              onClick={onClose}
              className="login-modal-close"
              type="button"
            >
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <p className="login-modal-description">
            Veuillez vous connecter pour accéder au distributeur de tickets
          </p>

          <form onSubmit={handleLogin} className="login-form">
            {error && (
              <div className="login-error">
                <p>{error}</p>
              </div>
            )}

            <div className="form-group">
              <label htmlFor="username" className="form-label">
                Nom d'utilisateur
              </label>
              <input
                id="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="form-input"
                placeholder="Entrez votre nom d'utilisateur"
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Mot de passe
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                placeholder="Entrez votre mot de passe"
                required
              />
            </div>

            <div className="form-buttons">
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary"
              >
                {loading ? (
                  <>
                    <div className="loading-spinner"></div>
                    Connexion...
                  </>
                ) : (
                  'Se connecter'
                )}
              </button>
              <button
                type="button"
                onClick={onClose}
                className="btn btn-secondary"
              >
                Annuler
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;